import { __assign, __rest } from "tslib";
import React from 'react';
import PremiumFolderIcon from '../../../Icons/PremiumFolderDisc';
import FollowingWatchIcon from '../../../Icons/16x16/FollowingWatch';
import CoreIconSmall from '../../../Icons/CoreIconSmall';
var PremiumFolderDataIcon = function (_a) {
    var premiumFolderData = _a.premiumFolderData, iconProps = __rest(_a, ["premiumFolderData"]);
    switch (premiumFolderData === null || premiumFolderData === void 0 ? void 0 : premiumFolderData.type) {
        case 'paid':
            return React.createElement(PremiumFolderIcon, __assign({}, iconProps));
        case 'watchers':
            return React.createElement(FollowingWatchIcon, __assign({}, iconProps));
        case 'privileged':
            return React.createElement(CoreIconSmall, __assign({}, iconProps));
        default:
            return null;
    }
};
PremiumFolderDataIcon.displayName = 'PremiumFolderDataIcon';
export default PremiumFolderDataIcon;
//# sourceMappingURL=PremiumFolderDataIcon.js.map